import { render, staticRenderFns } from "./JVxeDetailsModal.vue?vue&type=template&id=568352fc&"
import script from "./JVxeDetailsModal.vue?vue&type=script&lang=js&"
export * from "./JVxeDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./JVxeDetailsModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568352fc')) {
      api.createRecord('568352fc', component.options)
    } else {
      api.reload('568352fc', component.options)
    }
    module.hot.accept("./JVxeDetailsModal.vue?vue&type=template&id=568352fc&", function () {
      api.rerender('568352fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/JVxeDetailsModal.vue"
export default component.exports